// extracted by mini-css-extract-plugin
module.exports = {"select_wrapper":"styles_select_wrapper__1YK5L","select":"styles_select__1P8Mw","label":"styles_label__2EUAY"};